<template>
  <header
    class="w-full bg-white flex justify-center item-center"
    style="
      height: 56px;
      min-width: 50rem;
      box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3);
    "
  >
    <div class="flex mx-auto" style="width: 920px">
      <div class="flex items-center">
        <router-link :to="{ name: 'Top' }">
          <img
            src="@/assets/images/LogoSeller.svg"
            alt="PRONIアイミツメンバーズ"
          />
        </router-link>
      </div>
      <div class="flex items-center ml-5">
        <span class="text-gray-92 font-semibold">{{ buyerCompanyName }}</span>
      </div>
      <div class="flex items-center ml-auto">
        <span
          v-if="$route.meta.isInput"
          class="font-semibold px-4 rounded-full"
          style="
            line-height: 28px;
            color: #6c7ece;
            background-color: rgba(108, 126, 206, 0.1);
          "
          >見積もり編集</span
        >
        <span
          v-if="$route.meta.isConfirm"
          class="font-semibold px-4 rounded-full"
          style="
            line-height: 28px;
            color: #6c7ece;
            background-color: rgba(108, 126, 206, 0.1);
          "
          >見積もり確認</span
        >
        <span
          v-if="$route.meta.isCompleted"
          class="font-semibold px-4 rounded-full"
          style="
            line-height: 28px;
            color: #6c7ece;
            background-color: rgba(108, 126, 206, 0.1);
          "
          >見積もり完了</span
        >
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    buyerCompanyName: String,
  },
  setup() {
    return {};
  },
};
</script>
